import "core-js/modules/es6.regexp.to-string";
import _JSON$stringify from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/core-js/json/stringify";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import _Promise from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/core-js/promise";
import _classCallCheck from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";

/*
 * @Author: Jhonsem
 * @Date: 2019-05-10 14:15:16
 * @Last Modified by: Jhonsem
 * @Last Modified time: 2019-05-10 15:09:25
 */
import { getLang, getUUid } from "../utils/apiHelper";
import * as constants from "./constants";
import HttpClient from "../http/index";

var CryptoJS = require("crypto-js");

import { clientError } from "@/api/utils/apiHelper";

var HoroScopeNewClient =
/*#__PURE__*/
function () {
  function HoroScopeNewClient() {
    _classCallCheck(this, HoroScopeNewClient);
  }

  _createClass(HoroScopeNewClient, [{
    key: "requestCommonFactory",
    value: function requestCommonFactory() {
      var req = {};
      req.headers = {};
      req.headers["User-Agent"] = constants.UA;
      return req;
    } //   categoryId = ["newest" /* NEWEST */,
    //   "hottest" /* HOTTEST */,
    //   "a3f167d517b03187842581188abc5742" /* EDITORS' PICKS */,
    //   "3ac06d88ef72143c950fb976d574ad2e" /* LOVE */,
    //   "5803dbf983766fb4573953d7620f9b7d" /* FUNNY */,
    //   "2586351c525f3793b98fa2592111e70e" /* PERSONALITY */,
    //   "0a04d0a96618eb0cc67aa1fa36511d13" /* CAREER */]
    // direction ["old", "new"] 拉取方向
    // nearestId 可选 拉取方向最近的id(new第一条,old最后一条)

    /**
     * @param categoryId
     * @param direction
     * @param nearestId
     */

  }, {
    key: "fetchArticleList",
    value: function fetchArticleList(categoryId, direction, nearestId) {
      var _this = this;

      return new _Promise(
      /*#__PURE__*/
      function () {
        var _ref = _asyncToGenerator(
        /*#__PURE__*/
        regeneratorRuntime.mark(function _callee(resolve, reject) {
          var req, content, contentStr, signature, res;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.prev = 0;
                  req = _this.requestCommonFactory();
                  content = {};
                  content.page_size = 1000;
                  content.muid = _this.deviceId;
                  content.category_id = categoryId;
                  content.direction = direction;

                  if (nearestId) {
                    content.nearest_article_id = nearestId;
                  }

                  contentStr = _JSON$stringify(content, null, 2);
                  signature = CryptoJS.HmacSHA256(contentStr, constants.SECRET_KEY).toString();
                  req.data = {};
                  req.data.content = contentStr;
                  req.data.signature = signature;
                  req.data.sig_kv = "503_1";
                  req.data.cten = "p";
                  _context.next = 17;
                  return HttpClient.post(constants.BASE_URL + constants.HORO_ARTICLE_LIST, req);

                case 17:
                  res = _context.sent;
                  resolve(res);
                  console.log("fetchArticleList res:", res);
                  _context.next = 27;
                  break;

                case 22:
                  _context.prev = 22;
                  _context.t0 = _context["catch"](0);
                  clientError("fetchArticleList", _context.t0);
                  reject(_context.t0);
                  console.log("fetchArticleList error:", _context.t0);

                case 27:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, null, [[0, 22]]);
        }));

        return function (_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "fetchArticleContent",
    value: function fetchArticleContent(articleId) {
      var _this2 = this;

      return new _Promise(
      /*#__PURE__*/
      function () {
        var _ref2 = _asyncToGenerator(
        /*#__PURE__*/
        regeneratorRuntime.mark(function _callee2(resolve, reject) {
          var req, content, contentStr, signature, res;
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.prev = 0;
                  req = _this2.requestCommonFactory();
                  content = {};
                  content.article_id = articleId;
                  contentStr = _JSON$stringify(content, null, 2);
                  req.params = {};
                  req.params.content = contentStr;
                  signature = CryptoJS.HmacSHA256(contentStr, constants.SECRET_KEY).toString();
                  req.params.signature = signature;
                  req.params.sig_kv = "503_1";
                  req.params.cten = "p";
                  _context2.next = 13;
                  return HttpClient.get(constants.BASE_URL + constants.HORO_ARTICLE_DETAIL, req);

                case 13:
                  res = _context2.sent;
                  resolve(res); // console.log("fetchArticleContent res:", res);

                  _context2.next = 21;
                  break;

                case 17:
                  _context2.prev = 17;
                  _context2.t0 = _context2["catch"](0);
                  clientError("fetchArticleContent", _context2.t0);
                  reject(_context2.t0); // console.log("fetchArticleContent error:", error);

                case 21:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, null, [[0, 17]]);
        }));

        return function (_x3, _x4) {
          return _ref2.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "language",
    get: function get() {
      return getLang();
    }
  }, {
    key: "deviceId",
    get: function get() {
      return getUUid();
    }
  }]);

  return HoroScopeNewClient;
}();

export default new HoroScopeNewClient();